import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import './Accordion.css';
import {
  HomeUpdatedonedev,
  HomeUpdatedtwodev,
  HomeUpdatedthreedev,
  HomeUpdatedfourdev,
  HomeUpdatedfivedev,
  HomeUpdatedsixdev,
  HomeUpdatedsevendev,
  HomeUpdatedeightdev,
  discoveryBackground,
  HomeUpdatedArrowIcon,
} from "../../../app-constants";

const AccordionItem = ({
  title,
  icon,
  contentMainTitle,
  contentMainContent,
  contentTitle,
  content,
  Link,
  isOpen,
  onToggle,
}) => {
  return (
    <div className="card">
      <div
        className={`card-header ${isOpen ? "active" : ""}`}
        onClick={onToggle}
      >
        {title}
        <div className="svg-arrow-icon d-block d-lg-none">
          {HomeUpdatedArrowIcon}
        </div>
      </div>
      <div className={`collapse ${isOpen ? "show width" : "width"}`}>
        <div className="card-body">
          <div className="discovery-bg">{discoveryBackground}</div>
          <div className="arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="36"
              fill="none"
              viewBox="0 0 20 36"
            >
              <path
                stroke="#F47A1F"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M1.893 2.377l15.62 15.62-15.62 15.62"
              ></path>
            </svg>
          </div>
          <div
            className="main-title"
            dangerouslySetInnerHTML={{ __html: contentMainTitle }}
          />
          <div className="main-title-content">
            <p dangerouslySetInnerHTML={{ __html: contentMainContent }} />
          </div>
          <div class="content-wrap">
            <div class="icon">{icon}</div>
            <h3
              className="title"
              dangerouslySetInnerHTML={{ __html: contentTitle }}
            />
            <p dangerouslySetInnerHTML={{ __html: content }} />
            {/* <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              {{ __html: Link }}
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

function DiscoveryAcc() {
  const [activeIndex, setActiveIndex] = useState(0);

  // const handleToggle = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };

  const handleToggle = (index) => {
    // Set activeIndex to the clicked index if it's different from the current active index
    setActiveIndex(activeIndex === index ? activeIndex : index);
  };

  return (
    <section className="tekrevol-home-discovery overflow-x-hidden b2b-portal-seamless telecom-process">
      <div className="accordion width" id="accordionHorizontalExample">
        <AccordionItem
          title="Market Research"
          contentMainTitle="Our Streamlined <span>Telecom Software Development</span> Process</span>"
          contentMainContent="TekRevol employs an agile development strategy to deliver innovative telecom software solutions quickly and flexibly. Our process adapts to emerging needs, ensuring clear communication and collaboration."
          icon={HomeUpdatedonedev}
          contentTitle="Market Research"
          content="As a leading telecom software development company, we initiate the process by developing a roadmap. Our experts conduct market analysis and business assessments before developing telecom software."
          // Link="Talk to Our Experts"
          isOpen={activeIndex === 0}
          onToggle={() => handleToggle(0)}
        />
        <AccordionItem
          title="Intuitive Design"
          contentMainTitle="Our Streamlined <span>Telecom Software Development</span> Process</span>"
          contentMainContent="TekRevol employs an agile development strategy to deliver innovative telecom software solutions quickly and flexibly. Our process adapts to emerging needs, ensuring clear communication and collaboration."
          icon={HomeUpdatedtwodev}
          contentTitle="Intuitive Design"
          content="We're proud to provide more than just attractive design. We combine scalability, well-designed UI/UX components, and easy navigation to create highly functioning software solutions."
          isOpen={activeIndex === 1}
          onToggle={() => handleToggle(1)}
        />
        <AccordionItem
          title="Development"
          contentMainTitle="Our Streamlined <span>Telecom Software Development</span> Process</span>"
          contentMainContent="TekRevol employs an agile development strategy to deliver innovative telecom software solutions quickly and flexibly. Our process adapts to emerging needs, ensuring clear communication and collaboration."
          icon={HomeUpdatedthreedev}
          contentTitle="Development"
          content="As a leading telecom software development company, we carefully choose the tech stack for software development. We create advanced Telecom IT software that works seamlessly across all platforms."
          isOpen={activeIndex === 2}
          onToggle={() => handleToggle(2)}
        />
        <AccordionItem
          title="Optimization and Testing"
          contentMainTitle="Our Streamlined <span>Telecom Software Development</span> Process</span>"
          contentMainContent="TekRevol employs an agile development strategy to deliver innovative telecom software solutions quickly and flexibly. Our process adapts to emerging needs, ensuring clear communication and collaboration."
          icon={HomeUpdatedfourdev}
          contentTitle="Optimization and Testing"
          content="Our QA testing services ensure seamless integration of new software solutions into your business processes. Our QA experts monitor performance, prevent bugs, and implement crucial improvements."
          isOpen={activeIndex === 3}
          onToggle={() => handleToggle(3)}
        />
        <AccordionItem
          title="Launch and Maintenance"
          contentMainTitle="Our Streamlined <span>Telecom Software Development</span> Process</span>"
          contentMainContent="TekRevol employs an agile development strategy to deliver innovative telecom software solutions quickly and flexibly. Our process adapts to emerging needs, ensuring clear communication and collaboration."
          icon={HomeUpdatedfivedev}
          contentTitle="Launch and Maintenance"
          content="After successful testing, we launch the product and provide ongoing support and maintenance. Our post-launch services ensure your telecom software remains up-to-date and functions smoothly."
          isOpen={activeIndex === 4}
          onToggle={() => handleToggle(4)}
        />
        {/* <AccordionItem
          title="Maintenance"
          contentMainTitle="Our Proven <span>AI Development Process</span> at TekRevol</span>"
          contentMainContent="We follow an agile-based process to develop, integrate, implement, and deploy artificial intelligence solutions. Our tried-and-tested 6-step process ensures your solutions are customized to your business needs and delivered within the budget on time."
          icon={HomeUpdatedsixdev}
          contentTitle="Maintenance"
          content="In the maintenance stage, we ensure the continuous optimal performance of your AI software through diligent monitoring and regular updates. We track key performance indicators (KPIs) detect anomalies or performance degradations, and take immediate corrective actions when necessary. Our team conducts periodic model retraining with new data to maintain accuracy and relevance. AI maintenance teams provide regular updates to ensure stability and efficiency."
          isOpen={activeIndex === 5}
          onToggle={() => handleToggle(5)}
        /> */}
        {/* <AccordionItem
          title="Support & Expand"
          contentMainTitle="TekRevol's <span>Ionic Development Process:</span> Your Pathway to Powerful Apps</span>"
          icon={HomeUpdatedsevendev}
          contentTitle="Support & Expand"
          content="We provide support and maintenance services for updating and optimizing your application further in use. We also work to expand and enhance your application, adding new features and functionalities as the business expands."
          isOpen={activeIndex === 6}
          onToggle={() => handleToggle(6)}
        /> */}
        {/* <AccordionItem
          title="Continuous Support & Optimization"
          contentMainTitle="Guided Roadmap to <span>Digital Success</span>"
          icon={HomeUpdatedeightdev}
          contentTitle="Continuous Support & Optimization"
          content="Offer ongoing support and optimization services. Monitor performance, gather feedback, and implement enhancements to drive sustained growth and innovation"
          isOpen={activeIndex === 7}
          onToggle={() => handleToggle(7)}
        /> */}
      </div>
    </section>
  );
}

export default DiscoveryAcc;
